import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

/**
 * Upload the HKID + student card images used to verify a personal sponsor
 * redemption (RN `uploadStudentDocsAPI`).
 * Backend: POST /api/user/uploadStudentDocs
 */
export const UploadStudentDocsAPI = async ({
  hkidUri,
  studentCardUri,
}: {
  hkidUri?: string;
  studentCardUri?: string;
}): Promise<ServiceResponse<any>> => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("POST", "api/user/uploadStudentDocs", {
      user_id: student?.id,
      hkidUri,
      studentCardUri,
    });
    return resp as ServiceResponse<any>;
  } catch (err) {
    console.error(`UploadStudentDocsAPI ${err}`);
    return { status: -1, error: err };
  }
};
